













import { Component, Prop, Vue } from 'vue-property-decorator';
import NewcrossButton from '@/components/atoms/NewcrossButton.vue';

@Component({
  components: {
    NewcrossButton,
  },
})
export default class DidYouKnow extends Vue {
  @Prop() text!: string;

  private showText = false;
}
